import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ApplicationStage, IAppConfig, IAppConfigs} from "../app-config.model";
import {environment} from "../../environments/environment";

@Injectable()
export class AppConfig {
  settings: IAppConfig;
  private readonly _defaultStage = ApplicationStage.DEFAULT;
  private readonly _configFilePath = `assets/config/config.json`;

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.http.get(this._configFilePath).subscribe({
        next: (response: IAppConfigs) => {
          const stage: ApplicationStage = environment.applicationStage as ApplicationStage;
          const defaultConfig = (<IAppConfigs>response)[this._defaultStage];

          if (!stage) {
            this.settings = defaultConfig;
          } else {
            const currentConfig = (<IAppConfigs>response)[stage];

            this.settings = {...defaultConfig, ...currentConfig};
          }

          resolve();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error: (response: any) => {
          reject(`Could not load file '${this._configFilePath}': ${JSON.stringify(response)}`);
        },
      });
    });
  }
}
